import { useShop } from "@/context/Shop";
import { formatALL, formatEUR, toEur } from "@/lib/format";

/**
 * Storefront price: ALL is the checkout currency and is always shown; EUR is a muted reference
 * computed with the admin exchange rate. The utility-bar toggle swaps which one is primary.
 */
export function Price({ value, full, onSale = false, size = "md", align = "left", showRef = true, className = "", testid = "price" }) {
  const { currencyMode } = useShop();
  if (value === null || value === undefined || value === "") return <span className={className}>—</span>;
  const eurPrimary = currencyMode === "EUR";
  const fmtPrimary = (v) => (eurPrimary ? `≈ ${formatEUR(toEur(v))}` : formatALL(v));
  const fmtRef = (v) => (eurPrimary ? formatALL(v) : `≈ ${formatEUR(toEur(v))}`);
  const sale = onSale && full && Number(full) > Number(value);
  const primaryCls = { sm: "text-[13px]", md: "text-[14px]", lg: "text-xl", xl: "text-2xl" }[size] || "text-[14px]";
  const refCls = { sm: "text-[11px]", md: "text-[12px]", lg: "text-[13px]", xl: "text-sm" }[size] || "text-[12px]";
  return (
    <span className={`inline-flex flex-col ${align === "right" ? "items-end" : "items-start"} ${className}`} data-testid={testid}>
      <span className={`tabular font-semibold leading-tight ${primaryCls} ${sale ? "text-[hsl(var(--sale))]" : ""}`} data-testid={`${testid}-primary`}>
        {fmtPrimary(value)}
        {sale && <span className={`ml-2 font-normal line-through text-muted-foreground ${refCls}`} data-testid={`${testid}-compare`}>{fmtPrimary(full)}</span>}
      </span>
      {showRef && <span className={`tabular text-muted-foreground leading-tight mt-0.5 ${refCls}`} data-testid={`${testid}-reference`}>{fmtRef(value)}</span>}
    </span>
  );
}

/** Inline single-line price (used in dense places such as search results and bag lines). */
export function PriceInline({ value, full, onSale = false, className = "", testid = "price-inline" }) {
  const { currencyMode } = useShop();
  if (value === null || value === undefined || value === "") return <span className={className}>—</span>;
  const eurPrimary = currencyMode === "EUR";
  const fmt = (v) => (eurPrimary ? `≈ ${formatEUR(toEur(v))}` : formatALL(v));
  const sale = onSale && full && Number(full) > Number(value);
  return (
    <span className={`tabular ${className}`} data-testid={testid}>
      <span className={`font-semibold ${sale ? "text-[hsl(var(--sale))]" : ""}`}>{fmt(value)}</span>
      {sale && <span className="ml-2 line-through text-muted-foreground font-normal">{fmt(full)}</span>}
    </span>
  );
}
